/**
 * SystemDebug - System debugging module used to log navigation, results from API calls, and errors.
 * There are two levels to the debug - the run-time console logging and the storage of log information for
 * presentation in the app or for posting to the back-end system.
 */
import moment from "moment";

const components = [
	"none",
	//"AI",
	//"App",
	//"Courses",
	//"MdlCourse",
	//"Popup",
	//"Share",
	//"Storage",
	"WebService"
];

export interface DebugLog {
	timestamp: string,
	direction: string,
	component: string,
	module: string,
	data: any // is an ellipsis value (arrays, strings, objects)
}

export let SystemDebug = (function () {

	/**
	 * Log an event, error, or status update.
	 * @param component is the name of the component (e.g. MdlCourse, WebService, ...)
	 * @param module is the name of the function (e.g. bn_get_strings, mdl_get_courses, ...)
	 * @param direction identifies one of the following (in-API call, out-API results, app-internal to the APP)
	 * @param data is an ellipses value that contains the raw data.
	 */
	function log(component: string, module: string, direction: string, ...data: any) {
		// Make sure we want to create the log.
		if (!components.includes(component)) {
			return;
		}

		// Record the debug message.
		const timestamp = moment().format('hh:mm:ss');
		if (!data || !data.length) {
			console.log(component, module, direction);
		} else {
			console.log(component, module, direction, data);
		}
	}

	/**
	 * PUBLIC ACCESS
	 */

	return {
		log: log
	}

})();
